<template>
</template>
<script>
import shine from '@/components/plugins/echarts-theme-shine';
// import energyData from '@/assets/energyData.json';

export default{
  data: () => ({
    dtwData: [],
    startDate: null,
    endDate: null,
  }),
  methods: {
    getData: _.debounce(async function() {
      if (this.runState === "running") {
        let startDate = this.startDate
        let endDate = this.endDate
        let hash = this.createHash("temp")
        
        try {
          // const url = 'http://localhost:8085/dtw' // for testing purposed (temporary)
          const url = 'https://fm-energywatch.ad.gatech.edu/rbsBackend/dtw'
          
          const bdata = {
            "hash":hash, 
            "start":startDate, 
            "end":endDate,
            
            "general":this.general,
            "lighting":this.lighting,
            "cop":this.COP,
            "HVACsys":this.HVACsys,
            "DHWsys":this.DHWsys,
            "PVsys":this.PVsys,

            "zone":this.zone,
            "envelope":this.envelope,
            "material":this.material,

            "schedule":this.schedule,
            "calibration":this.calibration,
            "calibration_table":this.calibration_table
            }
          const fetch_param = {
            method: 'POST',
            body: JSON.stringify(bdata, null, 2),
            headers: {"Content-type": "application/json"}
          }
          // console.log(bdata)
          const response = await fetch(url, fetch_param)
          const data = await response.json()
          this.dtwData = data
          this.updateData()
        } catch (error) {
          this.errorRun()
          console.log(error)
        }
      }
    }),
    createHash(str) {
      let seed = Math.floor(Math.random() * 10).toString()
      let h1 = 0xf1a2b23 ^ seed, h2 = 0x41c6ce57 ^ seed
      for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
      h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
      return (4294967296 * (2097151 & h2) + (h1>>>0)).toString(16).substr(-8)

    },
    updateVar() {
      this.startDate = this.$store.state.DTW.start
      this.endDate = this.$store.state.DTW.end
    },
    updateData() {
      this.$store.commit("updateDTW_data",this.dtwData)
      this.$store.commit("updateDTW_run", "finished")
    },
    errorRun() {
      this.$store.commit("updateDTW_run","idle")
    },
  },
  watch: {
    '$store.state.DTW.run': function() {
      if (this.$store.state.DTW.run === "running") {
        this.getData()
        this.updateVar()
      }
    },
  },
  computed: {
    runState(){
      return this.$store.state.DTW.run
    },
    general(){
      return this.$store.state.DTW.general
    },
    lighting(){
      return this.$store.state.DTW.lighting
    },
    COP(){
      return this.$store.state.DTW.COP
    },
    HVACsys(){
      return this.$store.state.DTW.HVACsys
    },
    DHWsys(){
      return this.$store.state.DTW.DHWsys
    },
    PVsys(){
      return this.$store.state.DTW.PVsys
    },
    zone(){
      return this.$store.state.DTW.zone
    },
    envelope(){
      return this.$store.state.DTW.envelope
    },
    material(){
      return this.$store.state.DTW.material
    },
    schedule(){
      return this.$store.state.DTW.schedule
    },
    calibration(){
      return this.$store.state.DTW.calibration
    },
    calibration_table(){
      return this.$store.state.DTW.calibration_table
    },
  },
}
</script>
